import React, { FC, useContext } from "react";
import { Container } from "@mui/material";
import NavigationItem from "./NavigationItem";
import Accordion from "../Common/Accordion/Accordion";
import { NavigationConfig } from "./types/navigationConfigType";
import PageThemeContext from "../../Contexts/pageThemeContext";

interface SideNavigationMenuProps {
  closeMenu: () => void;
  navigationConfigList: NavigationConfig[];
}

const SideNavigationMenu: FC<SideNavigationMenuProps> = (props) => {
  const { closeMenu, navigationConfigList } = props;
  const theme = useContext(PageThemeContext);

  return (
    <Container
      className={`sideNavigationMenu page-theme-${theme?.toLowerCase()}`}
      sx={{
        width: "100%",
        padding: "0px",
        background: "white",
        opacity: 1
      }}
    >
      {navigationConfigList.map((navConfig) =>
        navConfig.subLinks ? (
          <div
            style={{ borderBottom: "1px solid #f6f6f6" }}
            key={navConfig.path || navConfig.title}
          >
            <Accordion title={navConfig.title}>
              {navConfig.subLinks.map((link) => (
                <NavigationItem
                  key={link.path || link.title}
                  navConfig={link}
                  closeMenu={closeMenu}
                />
              ))}
            </Accordion>
          </div>
        ) : (
          <NavigationItem
            key={navConfig.path || navConfig.title}
            navConfig={navConfig}
            closeMenu={closeMenu}
          />
        )
      )}
    </Container>
  );
};

export default SideNavigationMenu;
